import { ThemeProvider } from "@mui/material";
import { theme } from "../assets/theme/theme";

export const MuiTheme = (props: any) => {
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
